"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeExampleOut = void 0;
class EventTypeExampleOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeExampleOut.attributeTypeMap;
    }
}
exports.EventTypeExampleOut = EventTypeExampleOut;
EventTypeExampleOut.discriminator = undefined;
EventTypeExampleOut.attributeTypeMap = [
    {
        "name": "example",
        "baseName": "example",
        "type": "{ [key: string]: any; }",
        "format": ""
    }
];
//# sourceMappingURL=EventTypeExampleOut.js.map